materialColorsConfig.$inject = ['$mdThemingProvider'];
export function materialColorsConfig($mdThemingProvider) {

  const fusePalettes = [
    // please note that some of these colors are duplicated in colors.scss; they must be modified in both places
    // (in angular 2+, Material's custom theme system seems to be sass-based, but not so in angularjs )
    // 
    // These palettes have been created with the help of http://mcg.mbitson.com/
    {
      'name': 'alcmeon-primary-blue',
      'options': {
        '50': 'e0eef8',
        '100': 'b3d5ee',
        '200': '80b9e3',
        '300': '4d9cd7', // hue-1
        '400': '2687cf',
        '500': '0072c6', // default -- main blue, e.g. for the top toolbar and default links        -- $lochmara
        '600': '006ac0',
        '700': '005fb9',
        '800': '0055b1', // hue-2
        '900': '0042a4',
        'A100': 'cedeff', // hue-3
        'A200': '9bbcff',
        'A400': '689aff',
        'A700': '4f89ff',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': [
          '50',
          '100',
          '200',
          '300',
          'A100',
          'A200',
          'A400',
          'A700'
        ]
      }
    },
    {
      'name': 'alcmeon-accent-blue',
      'options': {
        '50': 'e9f7fa',
        '100': 'c9eaf2',
        '200': 'a5dcea',
        '300': '80cee2',
        '400': '65c4db',
        '500': '4ab9d5',  //                                                                        -- $shakespeare
        '600': '43b2d0',
        '700': '3aaaca',
        '800': '3792a8',  // dark blue for side-nav select item bg                                  -- $boston-blue
        '900': '1d6f7d',  // dark blue for side-nav headers                                         -- $elm
        'A100': 'e9f7fa', // hue-1
        'A200': '4ab9d5', // default -- blue for sidenav background and some buttons, among others  -- $shakespeare
        'A400': '43b2d0', // hue-2
        'A700': '3aaaca', // hue-3
        'contrastDefaultColor': 'dark',
        'contrastLightColors': ['800', '900']
      }
    },
    {
      'name': 'alcmeon-background',
      'options': {
        '50': 'f2f5f5', // default -- light quasi-grey for main page background                     -- $porcelain
        '100': 'dee5e5', // hue-2                                                                   -- $geyser
        '200': 'c8d4d4',
        '300': 'b1c2c2', // hue-3
        '400': 'a1b5b5',
        '500': '90a8a8',
        '600': '88a0a0',
        '700': '7d9797',
        '800': '738d8d',
        '900': '2a454f', // dark turquoise/grey for main text color                                 -- $pickled-bluewood
        'A100': 'ffffff', // hue-1 -- white for cards background
        'A200': '2a454f', // dark turquoise/grey (material uses it for md-menu and md-calendar)     -- $pickled-bluewood
        'A400': '89ffff',
        'A700': '6fffff',
        'contrastDefaultColor': 'dark',
        'contrastLightColors': ['900']
      }
    }
  ];
  
  // Colors used directly in Material CSS, irrespective of theme config:
  // background:
  // 50
  // 100
  // 200
  // 300
  // 400
  // 500
  // 600
  // 700
  // 800
  // 900
  // A100
  // A200
  
  // primary:
  // 100
  // 200
  // 500
  // 600
  // 700
  
  // accent:
  // 100
  // A100
  // A200
  // A700



  // Define custom palettes
  angular.forEach(fusePalettes, function (palette) {
      $mdThemingProvider.definePalette(palette.name, palette.options);
  });

  // Register default themes
  $mdThemingProvider
    .theme('default')
      .primaryPalette('alcmeon-primary-blue')
      .accentPalette('alcmeon-accent-blue')
      .backgroundPalette('alcmeon-background')
      .warnPalette('red');

  const redForOlchmaraBg = $mdThemingProvider.extendPalette('red', {
    'A700': '#ff6040',
  });
  $mdThemingProvider.definePalette('red-for-olchmara-bg', redForOlchmaraBg);
  $mdThemingProvider
    .theme('lochmara-bg')
      .primaryPalette('alcmeon-primary-blue')
      .accentPalette('alcmeon-accent-blue')
      .backgroundPalette('alcmeon-background')
      .warnPalette('red-for-olchmara-bg');
}